import {
  ArrowUpDown,
  Bug,
  Car,
  CircleHelp,
  CloudRain,
  Droplets,
  GlassWater,
  KeyRound,
  Paintbrush,
  Refrigerator,
  ShieldCheck,
  Sparkles,
  Volume2,
  Wifi,
  Zap,
  type LucideIcon,
} from 'lucide-react';
import type { TicketCategory } from '@sf/shared';

const icons: Record<TicketCategory, LucideIcon> = {
  plumbing: Droplets,
  electrical: Zap,
  water_supply: GlassWater,
  lift: ArrowUpDown,
  door_lock: KeyRound,
  seepage: CloudRain,
  painting: Paintbrush,
  appliance: Refrigerator,
  pest_control: Bug,
  housekeeping: Sparkles,
  parking: Car,
  security: ShieldCheck,
  internet: Wifi,
  noise: Volume2,
  other: CircleHelp,
};

export function CategoryIcon({
  category,
  className,
}: {
  category: TicketCategory;
  className?: string;
}) {
  const Icon = icons[category] ?? CircleHelp;
  return <Icon className={className ?? 'size-5'} strokeWidth={1.75} aria-hidden />;
}
